module.exports = __webpack_public_path__ + "img/1.271b3bae.png";